var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0039 4H19.0039C19.5562 4 20.0039 4.44772 20.0039 5V17C20.0039 17.5523 19.5562 18 19.0039 18H1.00391C0.451626 18 0.00390625 17.5523 0.00390625 17V1C0.00390625 0.44772 0.451626 0 1.00391 0H16.0039V4ZM2.00391 6V16H18.0039V6H2.00391ZM2.00391 2V4H14.0039V2H2.00391ZM13.0039 10H16.0039V12H13.0039V10Z",
    fill: "#212348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/MyAccount.7344d7502283801fda4084b1c13bc562.svg";
export { ForwardRef as ReactComponent };